import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';


class BrowserRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data || !data.user_agent || !data.user_agent.client) {
      return null;
    }
    const { name, version } = data.user_agent.client;
    let icon = null;
    if (name === 'Firefox') {
      icon = 'firefox';
    } else if (name === 'Chrome') {
      icon = 'chrome';
    } else if (name === 'Microsoft Edge') {
      icon = 'edge';
    } else if (name === 'Safari') {
      icon = 'safari';
    }
    return (
      <span>{(icon !== null ?  <Fa name={icon} /> : '')} {name} {version}</span>
    );
  }
}

BrowserRenderer.propTypes = {
  data: PropTypes.shape({
    user_agent: PropTypes.shape({
      client: PropTypes.shape({
        name: PropTypes.string,
        version: PropTypes.string,
      }),
    }),
  }),
};
BrowserRenderer.defaultProps = {
  data: null,
};

export default BrowserRenderer;
